export default __webpack_public_path__ + "static/media/accountLockIcon.93543640.svg";